/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

export const Container = styled.div`
  & > div {
    margin-top: ${spacing.xSmall};
  }

  & div:first-of-type {
    margin: 0px;
  }
`;
